import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { FocusAreas } from '../components/FocusAreas';
import { PortfolioSection } from '../components/PortfolioSection';
function LeadershipCTA() {
  const navigate = useNavigate();
  return <section className="py-32 px-6 md:px-12 max-w-7xl mx-auto border-t border-avm-border" data-id="element-174">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className="flex flex-col md:flex-row md:items-end md:justify-between gap-8" data-id="element-175">
        <div data-id="element-176">
          <span className="text-avm-accent text-xs font-semibold tracking-[0.2em] uppercase mb-6 block" data-id="element-177">
            Leadership
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-avm-text mb-6" data-id="element-178">
            Operational & Technical Authority
          </h2>
          <p className="text-lg text-avm-textMuted font-light leading-relaxed max-w-2xl" data-id="element-179">
            Meet the team behind AVM — combining CFA-level financial rigor with
            decade-deep engineering leadership to transform complex, asset-heavy
            industries.
          </p>
        </div>

        <button onClick={() => {
        navigate('/leadership');
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} className="flex items-center gap-3 text-avm-text hover:text-avm-accent transition-colors duration-300 group pb-1 border-b border-avm-border hover:border-avm-accent shrink-0" data-id="element-180">
          <span className="font-medium tracking-wide" data-id="element-181">Meet the Team</span>
          <ArrowRightIcon className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-182" />
        </button>
      </motion.div>
    </section>;
}
export function HomePage() {
  return <>
      <HeroSection data-id="element-183" />
      <AboutSection data-id="element-184" />
      <FocusAreas data-id="element-185" />
      <PortfolioSection data-id="element-186" />
    </>;
}